const getListOfSundays = (numMonths = 3) => {
    const currentDate = new Date()
    const nextMonths = new Date(currentDate.setMonth(currentDate.getMonth() + numMonths))
    const sundays = []

    for (let d = new Date(); d <= nextMonths; d.setDate(d.getDate() + 1)) {
        if (d.getDay() === 0) {
            sundays.push(new Date(d))
        }
    }

    return sundays
}

export default getListOfSundays
